import { template } from 'lodash';
import axios from './client';

const SEARCH = '/social-media-image-template';
const CREATE = '/social-media-image-template';
const READ = template('/social-media-image-template/<%= id %>');
const UPDATE = template('/social-media-image-template/<%= id %>');
const DELETE = template('/social-media-image-template/<%= id %>');
const UPLOAD_IMAGE = template('/social-media-image-template/<%= id %>/image/upload');
const VALIDATE_IMAGE = '/social-media-image-template/image/validate';
const GET_PREVIEW = template('/social-media-image-template/<%= id %>/preview');
const DOWNLOAD = template('/social-media-image-template/<%= templateId %>/user/<%= userId %>/page/<%= pageId %>/download');

export function search(payload = {}) {
  return axios.get(SEARCH, { params: payload });
}

export function create(payload = {}) {
  return axios.post(CREATE, payload);
}

export function read(id) {
  return axios.get(READ({ id }));
}

export function update(id, payload = {}) {
  return axios.post(UPDATE({ id }), payload);
}

export function remove(id) {
  return axios.delete(DELETE({ id }));
}

export function uploadImage(id, payload) {
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(UPLOAD_IMAGE({ id }), payload, { headers });
}

export function validateImage(payload) {
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(VALIDATE_IMAGE, payload, { headers });
}

export function getPreview(id, payload) {
  return axios.post(GET_PREVIEW({ id }), payload, { responseType: 'blob' });
}

export function download(templateId, userId, pageId) {
  return axios.get(DOWNLOAD({ templateId, userId, pageId }), {
    'Content-Type': 'application/x-www-form-urlencoded',
    responseType: 'blob',
  });
}
